(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/views/list.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/views/list.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.views.List = Marionette.View.extend({
    className() {
      return 'margin-2';
    },
    regions() {
      return {
        soldAtRegion: "#winType".concat(this.options.model.get('winType'), "DivRegion")
      };
    },
    initialize() {
      this.mergeOptions(this.options, ['listType']);
    },
    template(data) {
      return svs.map_of_winners.templates.list(data);
    },
    templateContext() {
      return this.listType;
    },
    onRender() {
      this.showChildView('soldAtRegion', new Marionette.CollectionView({
        collection: this.collection.filterByAttributes({
          winType: this.model.get('winType')
        }, ['city', 'retailer', 'gameType', 'shares']),
        childView: svs.map_of_winners.views.ListWin,
        viewComparator: 'city'
      }));
    }
  });
})(Backbone, _, svs);

 })(window);